import { Paper, Title, Stack, Flex, Text, Button } from '@mantine/core';
import { trpc } from '../lib/trpc';
import type { SectionConfig } from '../lib/types';

interface SoftDeletePanelProps {
  config: SectionConfig;
  deletedItems: Record<string, unknown>[];
  onRestored: () => void;
}

function formatDeletedAt(row: Record<string, unknown>): string {
  const val = row['deleted'];
  if (!val) return '';
  return new Date(val as string).toLocaleString();
}

function getItemLabel(row: Record<string, unknown>): string {
  const candidates = ['name', 'title', 'label', 'email', 'username'];
  for (const key of candidates) {
    if (typeof row[key] === 'string' && row[key]) return row[key] as string;
  }
  return String(row['id'] ?? '?');
}

export default function SoftDeletePanel({ config, deletedItems, onRestored }: SoftDeletePanelProps) {
  const restoreMutation = trpc.admin.crud.restore.useMutation({ onSuccess: onRestored });
  if (deletedItems.length === 0) return null;

  return (
    <Paper withBorder p="md" mt="lg" bg="orange.0">
      <Title order={4} mb="sm">Recently Deleted</Title>
      <Stack gap="sm">
        {deletedItems.map((item) => {
          const id = Number(item['id']);
          return (
            <Flex key={id} align="center" justify="space-between" gap="md">
              <Text>
                <strong>{getItemLabel(item)}</strong>
                <Text component="span" c="dimmed" size="sm" ml="sm">
                  deleted {formatDeletedAt(item)}
                </Text>
              </Text>
              <Button
                variant="light"
                size="xs"
                loading={restoreMutation.isPending}
                onClick={() => restoreMutation.mutate({ entity: config.entity, id })}
              >
                Restore
              </Button>
            </Flex>
          );
        })}
      </Stack>
    </Paper>
  );
}
